import { render } from "./patient-appointment-details-modal.vue?vue&type=template&id=e40d6026"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__